var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8681",
    "data-name": "Group 8681",
    transform: "translate(-1220 -16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4314",
    "data-name": "Rectangle 4314",
    width: 36,
    height: 36,
    rx: 8,
    transform: "translate(1220 16)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g537",
    transform: "translate(1002.6 27.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g539",
    transform: "translate(228 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8253",
    "data-name": "Group 8253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path549",
    d: "M-563.755-161.444a3.138,3.138,0,0,1,1.223,2.5v5.276a3.136,3.136,0,0,1-3.136,3.136H-574.2a3.136,3.136,0,0,1-3.136-3.136v-5.276a3.135,3.135,0,0,1,1.234-2.493l4.264-3.253a3.136,3.136,0,0,1,3.8,0l2.363,1.8v-2.067",
    transform: "translate(577.332 165.333)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g551",
    transform: "translate(4.757 6.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path553",
    d: "M-32.317,0a1.016,1.016,0,0,0-1.016,1.016,1.016,1.016,0,0,0,1.016,1.016A1.016,1.016,0,0,0-31.3,1.016,1.016,1.016,0,0,0-32.317,0",
    transform: "translate(33.333 0)",
    fill: "#0a64f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g555",
    transform: "translate(8.01 6.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path557",
    d: "M-32.317,0a1.016,1.016,0,0,0-1.016,1.016,1.016,1.016,0,0,0,1.016,1.016A1.016,1.016,0,0,0-31.3,1.016,1.016,1.016,0,0,0-32.317,0",
    transform: "translate(33.333 0)",
    fill: "#0a64f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g559",
    transform: "translate(4.757 9.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path561",
    d: "M-32.317,0a1.016,1.016,0,0,0-1.016,1.016,1.016,1.016,0,0,0,1.016,1.016A1.016,1.016,0,0,0-31.3,1.016,1.016,1.016,0,0,0-32.317,0",
    transform: "translate(33.333 0)",
    fill: "#0a64f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g563",
    transform: "translate(8.01 9.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path565",
    d: "M-32.317,0a1.016,1.016,0,0,0-1.016,1.016,1.016,1.016,0,0,0,1.016,1.016A1.016,1.016,0,0,0-31.3,1.016,1.016,1.016,0,0,0-32.317,0",
    transform: "translate(33.333 0)",
    fill: "#0a64f9"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.9ee25b560b0b08749a299e50cac81d9c.svg";
export { ForwardRef as ReactComponent };